export default "__VITE_PUBLIC_ASSET__29e2c855__"